import { render, staticRenderFns } from "./UpdateIcon.vue?vue&type=template&id=5c690d33&scoped=true"
import script from "./UpdateIcon.vue?vue&type=script&lang=js"
export * from "./UpdateIcon.vue?vue&type=script&lang=js"
import style0 from "./UpdateIcon.vue?vue&type=style&index=0&id=5c690d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c690d33",
  null
  
)

export default component.exports